// extracted by mini-css-extract-plugin
export var cancelButton = "_li-5";
export var content = "_li-3";
export var createButton = "_li-6";
export var drawerContainer = "_li-0";
export var footer = "_li-2";
export var header = "_li-1";
export var orderFormColumn = "_li-4";